export class UserRole {
	NameToDisplay: string;
	constructor(public Id: string, public Name: string, public Description: string){
		this.NameToDisplay = !Description ? `${Name}` : `${Name} - ${Description}`;
	}
}
